import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  client: {
    NEXT_PUBLIC_SERVER_URL: z.string().url(),
    GTM_ID: z.string().optional(),
    NEXT_PUBLIC_POWER_BI_DISABLED: z.preprocess(
      (v) => v === 'true',
      z.boolean().default(false),
    ),
  },
  runtimeEnv: {
    NEXT_PUBLIC_SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL,
    GTM_ID: process.env.GTM_ID,
    NEXT_PUBLIC_POWER_BI_DISABLED: process.env.NEXT_PUBLIC_POWER_BI_DISABLED,
  },
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  emptyStringAsUndefined: true,
});
